"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidHttpUrl = exports.ensureEnvVar = exports.validateVariable = exports.validateBooleanVariable = exports.validateNumberVariable = exports.validateStringVariable = void 0;
const errors_1 = require("../types/errors");
const validateVariables_1 = require("../types/validateVariables");
/**
 * @description
 * Utility Function to handle the string variable validation.
 * @param {string} variableName - name of the variable for better error message.
 * @param {unknown} value - any value
 * @param {StringVariable} config = StringVariable
 * @returns {unknown} value
 * */
function validateStringVariable(variableName, value, config) {
    if (typeof value !== "string") {
        throw new errors_1.InvalidVariableType(variableName, validateVariables_1.VariableType.string, typeof value);
    }
    if (config.minLength && config.minLength > value.length) {
        throw new errors_1.InvalidVariableMinLength(variableName, config.minLength);
    }
    if (config.maxLength && value.length > config.maxLength) {
        throw new errors_1.InvalidVariableMaxLength(variableName, config.maxLength);
    }
    if (config.pattern && !config.pattern.regex.test(value)) {
        throw new errors_1.InvalidVariablePattern(variableName, config.pattern.placeholder, config.pattern.name);
    }
    return value;
}
exports.validateStringVariable = validateStringVariable;
/**
 * @description
 * Utility Function to handle the Number variable validation.
 * @param {string} variableName - name of the variable for better error message.
 * @param {unknown} value - any value
 * @param {NumberVariable} config = NumberVariable
 * @returns {Number} value
 * */
function validateNumberVariable(variableName, value, config) {
    const val = Number(value);
    if (typeof value !== "number" && Number.isNaN(val)) {
        throw new errors_1.InvalidVariableType(variableName, validateVariables_1.VariableType.number, typeof value);
    }
    if (config.min && config.min > val) {
        throw new errors_1.InvalidVariableMinLength(variableName, config.min);
    }
    if (config.max && val > config.max) {
        throw new errors_1.InvalidVariableMaxLength(variableName, config.max);
    }
    return val;
}
exports.validateNumberVariable = validateNumberVariable;
function validateBooleanVariable(variableName, value, config) {
    if (typeof value !== config.type) {
        throw new errors_1.InvalidVariableType(variableName, validateVariables_1.VariableType.boolean, typeof value);
    }
    return !!value;
}
exports.validateBooleanVariable = validateBooleanVariable;
/**
 * @description
 * Utility Function to handle the Variable validation.
 * @param {string} variableName - name of the variable for better error message.
 * @param {unknown} value - any value
 * @param {IVariable} config = IVariable
 * @returns {unknown} value
 * */
function validateVariable(variableName, value, config) {
    let val;
    switch (config.type) {
        case validateVariables_1.VariableType.number:
            val = validateNumberVariable(variableName, value, config);
            break;
        case validateVariables_1.VariableType.string:
            val = validateStringVariable(variableName, value, config);
            break;
        case validateVariables_1.VariableType.boolean:
            val = validateBooleanVariable(variableName, value, config);
            break;
        default: {
            const error = new errors_1.UnknownVariableType();
            throw error;
        }
    }
    return val;
}
exports.validateVariable = validateVariable;
/**
 * @description
 * Utility function for making sure the variable from environment.
 * @param {string} name - name of the variable in the environment.
 * @param {IVariable} config - configuration to apply on the variable.
 * @returns {string | number} value
 * */
function ensureEnvVar(name, config) {
    const value = process.env[name];
    if (!value) {
        const error = new errors_1.ServerMissingEnvVariableError(name);
        throw error;
    }
    try {
        const validatedValue = validateVariable(name, value, config);
        return validatedValue;
    }
    catch (error) {
        if (error instanceof Error) {
            const err = new errors_1.ServerInvalidEnvVariableError(name, error);
            throw err;
        }
        else {
            throw error;
        }
    }
}
exports.ensureEnvVar = ensureEnvVar;
/**
 * @description
 * check the url is a valid url
 * @param {string} inputUrl - inputUrl variable.
 * @returns {boolean} - true | false
 * */
function isValidHttpUrl(inputUrl) {
    let url;
    try {
        url = new URL(inputUrl);
    }
    catch {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}
exports.isValidHttpUrl = isValidHttpUrl;
//# sourceMappingURL=validateVariables.js.map